var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenClip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.94 74.176L437.824 14.06C419.076 -4.687 388.581 -4.687 369.834 14.06L313.342 70.677L441.323 198.658L497.94 142.166C516.687 123.419 516.687 92.924 497.94 74.176ZM251.101 53.68C235.479 38.057 210.232 38.057 194.61 53.68L75.753 172.412C69.503 178.661 69.503 188.784 75.753 195.033L87.062 206.343C93.311 212.592 103.435 212.592 109.684 206.343L222.856 93.296L256.789 127.23L94 290.019C41.508 342.511 8.388 411.376 0.139 485.115V485.365C-1.486 500.613 11.387 513.486 26.635 511.861C100.499 503.737 169.364 470.617 221.981 418L418.701 221.28L251.101 53.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenClip);
export default __webpack_public_path__ + "static/media/pen-clip.3739393ce56dc8b9fbdd1dd33d28bed4.svg";
export { ForwardRef as ReactComponent };